import i18next from "i18next";
import { useEffect, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Style from './style';
import { Select } from "../Select";
import { languages } from './config';
import CustomButton from "../Button";
import { useForms } from "../../context/Forms";
import { changeLanguage } from "../../helpers/Language";
import TazamaExtraButtons from "./components/extra-buttons/Tazama";
import { CustomIcon } from "datastake-daf/dist/components";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";

const appLogos = {
  tazama: '/assets/images/applications/tazama-logo.svg'
};

const renderAppExtra = ({ app, isHomePage }) => {
  switch (app) {
    case 'tazama':
      return <TazamaExtraButtons isHomePage={isHomePage} />
    default:
      return null;
  }
};

export default function Navbar({
  app,
  onClose,
  isHomePage = false,
  goToWebiste = true,
}) {
  const { t } = useTranslation();
  const goTo = useNavigate();
  const { pathname } = useLocation();
  const { authenticationLinks, setAuthenticationLinks } = useForms();
  const link = goToWebiste ? process.env.REACT_APP_LANDING_PAGE_URL : `/`;

  useEffect(() => {
    setAuthenticationLinks((prev) => [...prev.filter((p) => p !== pathname), pathname]);
  }, []);

  const renderBackButton = () => {
    if (authenticationLinks.length <= 1) {
      return !goToWebiste ? (
        <Link to={link}>
          <CustomButton type="default" onClick={() => setAuthenticationLinks([])}>
            {t('Back')}
          </CustomButton>
        </Link>
      ) : (
        <a href={link}>
          <CustomButton type="default">
            {t('Back')}
          </CustomButton>
        </a>
      );
    }

    return (
      <CustomButton
        type="default"
        onClick={() => {
          setAuthenticationLinks((prev) => [...prev.filter((p, i) => i !== authenticationLinks.length - 1)]);
          goTo(authenticationLinks[authenticationLinks.length - 2]);
        }}
      >
        {t('Back')}
      </CustomButton>
    );
  };

  const defaultValue = useMemo(() => {
    if (i18next.language.includes('en')) {
      return 'en';
    }

    if (i18next.language.includes('fr')) {
      return 'fr';
    }

    return i18next.language;
  }, [i18next.language]);

  return (
    <Style className={formatClassname([typeof onClose === 'function' && 'bordered'])}>
      <div className="d-navbar flex-c jus-c">
        <div className="main-cont d-container">
          <div className="left flex-c jus-c">
            <div className="flex-c jus-c">
              {app ? appLogos[app] ? (
                <Link to={link}>
                  <img src={appLogos[app]} alt='Datastake Logo' />
                </Link>
              ) : null : (
                <a href={`${process.env.REACT_APP_LANDING_PAGE_URL}?language=${i18next.language}`}>
                  <img src="/assets/images/datastake-logo.svg" alt='Datastake Logo' />
                </a>
              )}
            </div>
          </div>
          <div className="right">
            {typeof onClose === 'function' ? (
              <div className="cursor-pointer" onClick={onClose}>
                <CustomIcon name="Close" width={10} height={10} />
              </div>
            ) : (
              <>
                <Select
                  bordered={['tazama'].includes(app)}
                  values={languages}
                  defaultValue={defaultValue}
                  onChange={(val) => {
                    changeLanguage(val);
                  }}
                />

                {!app ? renderBackButton() : renderAppExtra({ app, isHomePage })}
              </>
            )}
          </div>
        </div>
      </div>
    </Style >
  );
}
